// deno-lint-ignore-file no-explicit-any no-window
import { useEffect, useRef, useState } from "hono/jsx";

interface UseBBConnectionProps {
  roomId: string;
  user?: { id: string; isAnonymous?: boolean };
}

export function useBBConnection({ roomId, user: _user }: UseBBConnectionProps) {
  const [connected, setConnected] = useState(false);
  const [roomNotFound, setRoomNotFound] = useState(false);
  const wsRef = useRef<WebSocket | null>(null);

  useEffect(() => {
    if (roomNotFound) return;

    let ws: WebSocket;
    let reconnectTimer: number;

    const connect = () => {
      const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
      const url = `${protocol}//${window.location.host}/ws/bb?room=${roomId}`;

      ws = new WebSocket(url);
      wsRef.current = ws;

      ws.onopen = () => {
        console.log("[BB] Connected");
        setConnected(true);
      };

      ws.onmessage = (event) => {
        const msg = JSON.parse(event.data);
        if (msg.type === "ROOM_NOT_FOUND") {
          setRoomNotFound(true);
          ws.close();
        } else {
          // Dispatch event for game script
          globalThis.dispatchEvent(
            new CustomEvent("bb:message", { detail: msg }),
          );
        }
      };

      ws.onclose = () => {
        console.log("[BB] Disconnected");
        setConnected(false);
        // Simple reconnect logic
        if (!roomNotFound) {
          reconnectTimer = setTimeout(connect, 3000);
        }
      };
    };

    connect();

    return () => {
      if (ws) ws.close();
      clearTimeout(reconnectTimer);
    };
  }, [roomId, roomNotFound]);

  const sendMessage = (msg: any) => {
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify(msg));
    }
  };

  return { connected, roomNotFound, setRoomNotFound, sendMessage };
}
